import { NgModule } from "@angular/core"
import { Route, RouterModule, UrlMatchResult, UrlSegment, UrlSegmentGroup } from "@angular/router"
import { Routes } from "@angular/router"

import { BrowsingComponent } from "./browsing.component"

export function customMatcher(
    segments: UrlSegment[],
    group: UrlSegmentGroup,
    route: Route
): UrlMatchResult {
    const nodeSlug = segments.map((segment) => segment.path).join("/")
    const nodeSlugSegment = new UrlSegment(nodeSlug, { nodeSlug: nodeSlug })
    return { consumed: segments, posParams: { nodeSlug: nodeSlugSegment } }
}

const browsingRoutes: Routes = [
    {
        matcher: customMatcher,
        component: BrowsingComponent,
    },
]

@NgModule({
    imports: [RouterModule.forChild(browsingRoutes)],
    exports: [RouterModule],
})
export class BrowsingRoutingModule {}
